import { Button } from "@/components/ui/button";
import { CopyIcon } from "lucide-react";
import { toast } from "sonner";

interface CopyToClipboardButtonProps {
	icon: React.ReactNode;
	value: string;
	label: string;
}

export const CopyToClipboardButton = (props: CopyToClipboardButtonProps) => {
	const { icon, value, label } = props;

	return (
		<Button
			key={label}
			variant="secondary"
			size="sm"
			className="flex items-center gap-2 px-3 py-1.5 text-sm"
			onClick={() => {
				navigator.clipboard
					.writeText(value || "")
					.then(() => toast.success(`${label} kopiert!`))
					.catch(() =>
						toast.error(`Kunne ikke kopiere ${label.toLowerCase()}`)
					);
			}}
		>
			{icon}
			{value || `Ingen ${label.toLowerCase()}`}
			<CopyIcon className="h-4 w-4" />
		</Button>
	);
};
